<template>
  <div>
    <CrudList
        title="Precios de consultas"
        storeName="Appointment_prices"
        parentStoreName="Specialities"
        parentUrlKey="speciality_id"
        :canAdd="true"
        :canEdit="true"
        :canDelete="true"
        labelAddNew="Crear Nuevo"
        labelEdit="Editar"
        labelDelete="Eliminar"
        labelBack="Atrás"
        sortable
    >
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
  data: () => ({
    offsetTop: 0,
  }),
  methods: {
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    },

  },
};
</script>
